import { render } from "./FullBodyCharacter.vue?vue&type=template&id=c324b268&scoped=true"
import script from "./FullBodyCharacter.vue?vue&type=script&lang=js"
export * from "./FullBodyCharacter.vue?vue&type=script&lang=js"

import "./FullBodyCharacter.vue?vue&type=style&index=0&id=c324b268&scoped=true&lang=css"

import exportComponent from "/Users/macpc-2/Downloads/Sitepal-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c324b268"]])

export default __exports__